import { useEffect, useRef } from 'react';
import VillaflorNavbar from './components/VillaflorNavbar';
import VillaflorHero from './components/VillaflorHero';
import AvailabilitySearchBar from '@/components/feature/AvailabilitySearchBar';
import VillaflorAmenities from './components/VillaflorAmenities';
import VillaflorDescription from './components/VillaflorDescription';
import VillaflorGallery from './components/VillaflorGallery';
import VillaflorFeatures from './components/VillaflorFeatures';
import VillaflorLayout from './components/VillaflorLayout';
import VillaflorMap from './components/VillaflorMap';
import VillaflorRules from './components/VillaflorRules';
import VillaflorCTA from './components/VillaflorCTA';
import Footer from '@/pages/home/components/Footer';
import VillaBookingSection from '@/components/feature/VillaBookingSection';

export default function CasaDeLaVillaflor() {
  const observerRef = useRef<IntersectionObserver | null>(null);

  useEffect(() => {
    observerRef.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    const elements = document.querySelectorAll('.scroll-reveal');
    elements.forEach((el) => observerRef.current?.observe(el));

    return () => {
      observerRef.current?.disconnect();
    };
  }, []);

  return (
    <main>
      <VillaflorNavbar />
      <VillaflorHero />
      <AvailabilitySearchBar villaSlug="casa-de-la-villaflor" />
      <VillaBookingSection villaSlug="casa-de-la-villaflor" />
      <VillaflorAmenities />
      <VillaflorDescription />
      <VillaflorGallery />
      <VillaflorFeatures />
      <VillaflorLayout />
      <VillaflorMap />
      <VillaflorRules />
      <VillaflorCTA />
      <Footer />
    </main>
  );
}